import './_export.scss';
import './_export.dark-mode.scss';
import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from 'react-bootstrap';
import qs from 'qs';

import Pagination from '../../../components/Pagination';
import CustomizeModal from '../../../components/Modal/Customize';
import OrdersForm from './components/Form';
import Table from './components/Table';
import Loader from '../../../components/Loaders/Loader';

import { ordersSelector } from '../../../redux/selectors/orders';
import { getOrdersExportConfigActions, getExportListAction } from '../../../redux/actions/orders';
import { validExportColumns } from './helpers';

const Export = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const queryString = qs.parse(location.search.slice(1));

  const { users, exportData, exportConfig } = useSelector((state) => ordersSelector(state));
  const { exports: items, pagination } = exportData;
  const { fields, export_columns, access } = exportConfig;
  const valideExportColumns = validExportColumns(export_columns, fields);

  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [includeColumns, setInclude] = useState([]);
  const toggle = () => setOpen(!open);

  useEffect(() => {
    setIsLoading(true);
    Promise.all([dispatch(getOrdersExportConfigActions()), dispatch(getExportListAction(queryString))])
      .then(() => setIsLoading(false))
      .catch(() => setIsLoading(false));

    document.title = 'Orders export';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, dispatch]);

  useEffect(() => {
    setInclude(valideExportColumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [export_columns]);

  if (access?.export_list === false) {
    history.push('/orders');
  }

  return (
    <Grid fluid>
      <CustomizeModal
        open={open}
        toggle={toggle}
        className="customize__modal"
        items={valideExportColumns}
        setInclude={setInclude}
        include={includeColumns}
        fields={fields}
      />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {access?.export_make && (
            <OrdersForm include={includeColumns} toggle={toggle} users={users} queryString={queryString} config={exportConfig} />
          )}
          <Table access={access} items={items} />
          <Pagination
            pages={pagination?.pages}
            currentPage={pagination?.current_page}
            itemsCount={pagination?.total_count}
            pageSize={pagination?.page_size}
            pagesLimit={pagination?.pages < 10 ? pagination?.pages : 10}
          />
        </>
      )}
    </Grid>
  );
};

export default Export;
